import { Mapa as c } from "../EditPanel/Mapa";
import { conLanding } from "../Models/Landing";

export default class Mapa extends c {
    con = conLanding();
    getDataSave2 = (): any => {
        const a = this.getDataSave();
        return { ...a, ...this.props.props };
    }
}